import { styled } from "@mui/material";

const WhatIsBizDev = () => {
  return (
    <Root>
      <h1>What is the Tublian Freelance Internship?</h1>
      <p>
        Tublian’s six‑week program turns developers, designers, writers,
        marketers, and other knowledge workers into paid freelancers. Live
        classes, 1‑on‑1 mentorship, and the Agencer—your personal AI for
        prospecting and pitching—guide you from zero clients to your first
        contract on platforms like Upwork/LinkedIn.
      </p>
    </Root>
  );
};

export default WhatIsBizDev;

const Root = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  textAlign: "center",
  width: "831px",
  gap: "20px",
  margin: "auto",
  color: "#fefefe",
  "&>h1": {
    fontSize: "48px",
    lineHeight: 1.33,
    fontWeight: 700,
    [theme.breakpoints.down(900)]: {
      width: "100%",
      paddingInline: "20px",
      fontSize: "35px",
      lineHeight: 1.3,
    },
    [theme.breakpoints.down(500)]: {
      fontSize: "24px",
      lineHeight: "35px",
    },
  },
  "&>p": {
    fontSize: "20px",
    lineHeight: "32px",
    fontWeight: 400,
    [theme.breakpoints.down(500)]: {
      fontSize: "16px",
      lineHeight: "24px",
      fontWeight: 500,
    },
  },
  [theme.breakpoints.down(900)]: {
    width: "100%",
    paddingInline: "20px",
  },
}));
